<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
// import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Classes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Streams",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Streams",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Stream Name",
          sortable: true,
        },
        {
          key: "class.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "user.name",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        class: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        class: "",
        id: "",
      },
      existingStream: [],
      nameError: "",
      classError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("classes", ["AllStreams", "AllClasses", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllStreams.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllStreams.length;
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      AddStream: "classes/addStream",
      EditStream: "classes/editStream",
      DeleteStream: "classes/deleteStream",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllStreams.length;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingStream = this.AllStreams.filter((stream) => {
          return stream.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingStream.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingStream = [];
      }
    },
    addStream(modal) {
      if (this.data.name == "") {
        this.nameError = "Stream Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.class == "") {
        this.classError = "Class field can't be empty";
        return;
      } else {
        this.classError = "";
      }
      // if (this.existingStream.length) {
      //     this.nameError = this.data.name + " exists already Please";
      //     return;
      //   } else {
      //     this.nameError = "";
      //   }
      this.modal = modal;
      this.AddStream(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.class = values.item.class.id;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteStream(modal) {
      this.modal = modal;
      this.DeleteStream(this.deletedata);
      this.closeModal(modal);
    },
    editStream(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Stream Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.EditStream(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStreams();
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_stream')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Available Streams
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-stream-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_stream')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllStreams"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-stream-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_stream')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-stream-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_stream')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-stream-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_stream')
          )
        "
      >
        <template #modal-title> Add New Stream </template>
        <div class="form-group mb-3">
          <label>Stream Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Stream Name"
              class="form-control"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Class</label>
          <div class="input-group">
            <!-- <model-list-select
              :list="AllClasses ? AllClasses : []"
              v-model="data.class"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Class"
              @input="resetError()"
            >
            </model-list-select> -->

            <select required v-model="data.class" class="form-control">
              <option v-if="SaveStatus" selected value="" disabled>
                Fetching Classes...
              </option>
              <option v-else selected value="" disabled>Select Class</option>
              <option
                v-for="(classes, index) in AllClasses"
                :key="index"
                :value="classes.id"
              >
                {{ classes.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="classError">
            <em>{{ classError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-stream-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addStream('add-stream-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-stream-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_stream')
          )
        "
      >
        <template #modal-title> Edit Stream {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Stream Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Class</label>
          <div class="input-group">
            <!-- <model-list-select
              :list="AllClasses ? AllClasses : []"
              v-model="editdata.class"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Class"
              @input="resetError()"
            >
            </model-list-select> -->

            <select required v-model="editdata.class" class="form-control">
              <option v-if="SaveStatus" selected value="" disabled>
                Fetching Classes...
              </option>
              <option v-else selected value="" disabled>Select Class</option>
              <option
                v-for="(classes, index) in AllClasses"
                :key="index"
                :value="classes.id"
              >
                {{ classes.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="classError">
            <em>{{ classError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-stream-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editStream('edit-stream-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete stream starts -->
      <b-modal
        id="delete-stream-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_stream')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Delete Stream {{ deletedata.name }}
          </h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6>
              Do you want to delete Stream <strong>{{ deletedata.name }}</strong
              >? <br /><br />
              Click <strong>Proceed</strong>
              Button to delete.
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-stream-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteStream('delete-stream-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
